import { useEffect } from "react";

export const SEO = ({ title, description }) => {
    useEffect(() => {
        document.title = title;
        const meta = document.querySelector('meta[name="description"]');
        if (meta && description) meta.setAttribute("content", description);
    }, [title, description]);
    return null;
};
